import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/auth/AuthProvider'
import { billingApi } from '@/lib/api/billing'

/**
 * The caller's consumption against their plan.
 *
 * Read before the person picks a file, not after the upload is refused —
 * "3 von 10 Seiten übrig" ahead of time is a different experience from a
 * 402 afterwards. Invalidate `['usage']` after anything that stores or
 * deletes a page.
 *
 * Only ever asked with a session. `/onboarding` is a public route and renders
 * quota components, and an authenticated request from there is not merely a
 * guaranteed 401: the 401 drives `apiClient`'s own refresh-and-retry, which
 * can race the bootstrap refresh `AuthProvider` fires on mount. Two requests
 * with the same rotating refresh cookie is exactly the token reuse the
 * gateway answers by revoking every session of that family — signing a
 * returning visitor out of all their devices for opening the funnel.
 */
export function useUsage() {
  const { signedIn } = useAuth()
  return useQuery({
    queryKey: ['usage'],
    queryFn: () => billingApi.usage(),
    enabled: signedIn,
    // Cheap, and wrong the moment a document lands.
    staleTime: 10_000,
  })
}
